module.exports = __webpack_public_path__ + "img/image_13.d01a6953.png";